import React from 'react'
import { arrayOf, bool, string } from 'prop-types'
import tabDataProp from 'utils/prop_types/TabData'
import classnames from 'classnames'

import Container from 'components/atoms/Container'
import { Fade } from 'components/atoms/Animista'

const TabsContent = ({ tabs, activeId, fullContent }) => (
  <div className="tab-content">
    {
      tabs.map((tab, idx) => (
        <Container
          className="tab-content__container"
          key={`tab-content-${tab.id}-${idx}`}
          fluid
        >
          <div className={classnames('tab-content__item', {
            active: activeId === tab.id,
          })}
          >
            <Fade active={activeId === tab.id}>
              { (fullContent &&
                <ul>
                  {tab.fullContent.map((item, i) => (<li key={i}>{item}</li>))}
                </ul>
                ) || tab.content
              }
            </Fade>
          </div>
        </Container>
      ))
    }
    <style jsx>
      {`
        .tab-content {
          padding: 24px 12px;
          border-bottom-left-radius: 8px;
          border-bottom-right-radius: 8px;
          &__item {
            display: none;
            font-size: 14px;
            line-height: 2;
            &.active {
              display: block;
            }
          }
        }
      `}
    </style>
  </div>
)

TabsContent.propTypes = {
  tabs: arrayOf(tabDataProp),
  activeId: string,
  fullContent: bool,
}

export default TabsContent
